import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Italian
import commonIt from './locales/it/common.json'
import landingIt from './locales/it/landing.json'
import loginIt from './locales/it/login.json'
import navbarIt from './locales/it/navbar.json'
import testIt from './locales/it/test.json'
import homeIt from './locales/it/home.json'
import settaggiIt from './locales/it/settaggi.json'
import clientiIt from './locales/it/clienti.json'
import preventiviIt from './locales/it/preventivi.json'
import ordiniIt from './locales/it/ordini.json'
import fattureIt from './locales/it/fatture.json'
import analisiIt from './locales/it/analisi.json'
import ecommerceIt from './locales/it/ecommerce.json'
import articoliIt from './locales/it/articoli.json'
import costruzioniIt from './locales/it/costruzioni.json'
import fotovoltaicoIt from './locales/it/fotovoltaico.json'
import boardIt from './locales/it/board.json'
import installazioniIt from './locales/it/installazioni.json'
import investimentiIt from './locales/it/investimenti.json'
import carrelloIt from './locales/it/carrello.json'
import investitoriIt from './locales/it/investitori.json'
import utentiIt from './locales/it/utenti.json'
import scontiIt from './locales/it/sconti.json'
import costiIt from './locales/it/costi.json'
import fornitoriIt from './locales/it/fornitori.json'
import scatoleIt from './locales/it/scatole.json'
import variabiliIt from './locales/it/variabili.json'
import rimborsiIt from './locales/it/rimborsi.json'
import serviziIt from './locales/it/servizi.json'
import progettiIt from './locales/it/progetti.json'
import canoniIt from './locales/it/canoni.json'
import ricaviIt from './locales/it/ricavi.json'
import uiIt from './locales/it/ui.json'
import aziendeIt from './locales/it/aziende.json'
import magazzinoIt from './locales/it/magazzino.json'
import modalsIt from './locales/it/modals.json'

// English
import commonEn from './locales/en/common.json'
import landingEn from './locales/en/landing.json'
import loginEn from './locales/en/login.json'
import navbarEn from './locales/en/navbar.json'
import testEn from './locales/en/test.json'
import homeEn from './locales/en/home.json'
import settaggiEn from './locales/en/settaggi.json'
import clientiEn from './locales/en/clienti.json'
import preventiviEn from './locales/en/preventivi.json'
import ordiniEn from './locales/en/ordini.json'
import fattureEn from './locales/en/fatture.json'
import analisiEn from './locales/en/analisi.json'
import ecommerceEn from './locales/en/ecommerce.json'
import articoliEn from './locales/en/articoli.json'
import costruzioniEn from './locales/en/costruzioni.json'
import fotovoltaicoEn from './locales/en/fotovoltaico.json'
import boardEn from './locales/en/board.json'
import installazioniEn from './locales/en/installazioni.json'
import investimentiEn from './locales/en/investimenti.json'
import carrelloEn from './locales/en/carrello.json'
import investitoriEn from './locales/en/investitori.json'
import utentiEn from './locales/en/utenti.json'
import scontiEn from './locales/en/sconti.json'
import costiEn from './locales/en/costi.json'
import fornitoriEn from './locales/en/fornitori.json'
import scatoleEn from './locales/en/scatole.json'
import variabiliEn from './locales/en/variabili.json'
import rimborsiEn from './locales/en/rimborsi.json'
import serviziEn from './locales/en/servizi.json'
import progettiEn from './locales/en/progetti.json'
import canoniEn from './locales/en/canoni.json'
import ricaviEn from './locales/en/ricavi.json'
import uiEn from './locales/en/ui.json'
import aziendeEn from './locales/en/aziende.json'
import magazzinoEn from './locales/en/magazzino.json'
import modalsEn from './locales/en/modals.json'

// French
import commonFr from './locales/fr/common.json'
import landingFr from './locales/fr/landing.json'
import loginFr from './locales/fr/login.json'
import navbarFr from './locales/fr/navbar.json'
import testFr from './locales/fr/test.json'
import homeFr from './locales/fr/home.json'
import settaggiFr from './locales/fr/settaggi.json'
import clientiFr from './locales/fr/clienti.json'
import preventiviFr from './locales/fr/preventivi.json'
import ordiniFr from './locales/fr/ordini.json'
import fattureFr from './locales/fr/fatture.json'
import analisiFr from './locales/fr/analisi.json'
import ecommerceFr from './locales/fr/ecommerce.json'
import articoliFr from './locales/fr/articoli.json'
import costruzioniFr from './locales/fr/costruzioni.json'
import fotovoltaicoFr from './locales/fr/fotovoltaico.json'
import boardFr from './locales/fr/board.json'
import installazioniFr from './locales/fr/installazioni.json'
import investimentiFr from './locales/fr/investimenti.json'
import carrelloFr from './locales/fr/carrello.json'
import investitoriFr from './locales/fr/investitori.json'
import utentiFr from './locales/fr/utenti.json'
import scontiFr from './locales/fr/sconti.json'
import costiFr from './locales/fr/costi.json'
import fornitoriFr from './locales/fr/fornitori.json'
import scatoleFr from './locales/fr/scatole.json'
import variabiliFr from './locales/fr/variabili.json'
import rimborsFr from './locales/fr/rimborsi.json'
import serviziFr from './locales/fr/servizi.json'
import progettiFr from './locales/fr/progetti.json'
import canoniFr from './locales/fr/canoni.json'
import ricaviFr from './locales/fr/ricavi.json'
import uiFr from './locales/fr/ui.json'
import aziendeFr from './locales/fr/aziende.json'
import magazzinoFr from './locales/fr/magazzino.json'
import modalsFr from './locales/fr/modals.json'

const STORAGE_KEY = 'ems-language'
const SUPPORTED = ['it', 'en', 'fr']
const DEFAULT_LANGUAGE = 'it'

const savedLang = localStorage.getItem(STORAGE_KEY)
const initialLang = SUPPORTED.includes(savedLang) ? savedLang : DEFAULT_LANGUAGE

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { common: commonIt, landing: landingIt, login: loginIt, navbar: navbarIt, test: testIt, home: homeIt, settaggi: settaggiIt, clienti: clientiIt, preventivi: preventiviIt, ordini: ordiniIt, fatture: fattureIt, analisi: analisiIt, ecommerce: ecommerceIt, articoli: articoliIt, costruzioni: costruzioniIt, fotovoltaico: fotovoltaicoIt, board: boardIt, installazioni: installazioniIt, investimenti: investimentiIt, carrello: carrelloIt, investitori: investitoriIt, utenti: utentiIt, sconti: scontiIt, costi: costiIt, fornitori: fornitoriIt, scatole: scatoleIt, variabili: variabiliIt, rimborsi: rimborsiIt, servizi: serviziIt, progetti: progettiIt, canoni: canoniIt, ricavi: ricaviIt, ui: uiIt, aziende: aziendeIt, magazzino: magazzinoIt, modals: modalsIt },
      en: { common: commonEn, landing: landingEn, login: loginEn, navbar: navbarEn, test: testEn, home: homeEn, settaggi: settaggiEn, clienti: clientiEn, preventivi: preventiviEn, ordini: ordiniEn, fatture: fattureEn, analisi: analisiEn, ecommerce: ecommerceEn, articoli: articoliEn, costruzioni: costruzioniEn, fotovoltaico: fotovoltaicoEn, board: boardEn, installazioni: installazioniEn, investimenti: investimentiEn, carrello: carrelloEn, investitori: investitoriEn, utenti: utentiEn, sconti: scontiEn, costi: costiEn, fornitori: fornitoriEn, scatole: scatoleEn, variabili: variabiliEn, rimborsi: rimborsiEn, servizi: serviziEn, progetti: progettiEn, canoni: canoniEn, ricavi: ricaviEn, ui: uiEn, aziende: aziendeEn, magazzino: magazzinoEn, modals: modalsEn },
      fr: { common: commonFr, landing: landingFr, login: loginFr, navbar: navbarFr, test: testFr, home: homeFr, settaggi: settaggiFr, clienti: clientiFr, preventivi: preventiviFr, ordini: ordiniFr, fatture: fattureFr, analisi: analisiFr, ecommerce: ecommerceFr, articoli: articoliFr, costruzioni: costruzioniFr, fotovoltaico: fotovoltaicoFr, board: boardFr, installazioni: installazioniFr, investimenti: investimentiFr, carrello: carrelloFr, investitori: investitoriFr, utenti: utentiFr, sconti: scontiFr, costi: costiFr, fornitori: fornitoriFr, scatole: scatoleFr, variabili: variabiliFr, rimborsi: rimborsFr, servizi: serviziFr, progetti: progettiFr, canoni: canoniFr, ricavi: ricaviFr, ui: uiFr, aziende: aziendeFr, magazzino: magazzinoFr, modals: modalsFr }
    },
    lng: initialLang,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
